export const EAN_PREFIX = "54";
export const EAN_LENGTH = 18;
export const EAN_MASK = `${EAN_PREFIX}${Array(EAN_LENGTH - EAN_PREFIX.length)
  .fill(0)
  .join("")}`;
